import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth'
import settings from './settings'
import users from './users'
import support from './support'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    auth,
    support,
    {
      path: '/',
      name: 'home',
      redirect: { name: 'users' },
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home'),
      children: [
        {
          path: 'companies',
          name: 'companies',
          component: () =>
            import(/* webpackChunkName: "companies" */ '@/views/Home/Companies')
        },
        {
          path: 'companies/:id',
          name: 'company.details',
          component: () =>
            import(
              /* webpackChunkName: "users" */ '@/views/Home/Companies/components/CompanyDetails'
            )
        },
        {
          path: 'content',
          name: 'content',
          component: () =>
            import(/* webpackChunkName: "content" */ '@/views/Home/Content')
        },
        {
          path: 'notification',
          name: 'notification',
          component: () =>
            import(
              /* webpackChunkName: "push-notification" */ '@/views/Home/Notification'
            )
        },
        users,
        settings,
        {
          path: 'providers',
          name: 'providers',
          component: () =>
            import(/* webpackChunkName: "providers" */ '@/views/Home/Providers')
        },
        {
          path: 'providers/add',
          name: 'providers.add',
          component: () =>
            import(
              /* webpackChunkName: "providers" */ '@/views/Home/Providers/AddProvider'
            )
        },
        {
          path: 'providers/:id',
          name: 'provider.details',
          component: () =>
            import(
              /* webpackChunkName: "providers" */ '@/views/Home/Providers/ProviderDetails'
            )
        },
        {
          path: 'reports',
          name: 'reports',
          component: () =>
            import(/* webpackChunkName: "reports" */ '@/views/Home/Reports')
        },
        {
          path: 'requests',
          name: 'requests',
          component: () =>
            import(/* webpackChunkName: "requests" */ '@/views/Home/Requests')
        },
        {
          path: 'requests/verified',
          name: 'requests.verified',
          component: () =>
            import(
              /* webpackChunkName: "requests" */ '@/views/Home/Requests/VerifiedList'
            )
        },
        {
          path: 'requests/:id',
          name: 'request.details',
          component: () =>
            import(
              /* webpackChunkName: "requests" */ '@/views/Home/Requests/RequestDetails'
            )
        }
      ]
    }
  ]
})
